<template>
    <div class="columns">
        <div class="column is-8 is-offset-2" v-if="!haveFightsForCurrentPage">
            <Notification class="is-warning">
                <span class="icon">
                    <i class="fa fa-exclamation-triangle" />
                </span>
                <span>{{ translate("announcer_board.no_fights") }}</span>
            </Notification>
        </div>

        <template v-for="mat in store.matsForGivenPage">
            <transition-group
                tag="div"
                name="list"
                v-if="filteredFightsForMat[mat.id]?.length > 0"
                class="column fights-list"
                :key="mat.id"
            >
                <div class="mat-name is-sticky-position" :key="mat.id">
                    {{ matNameById(mat.id) }}
                </div>

                <SingleFight
                    v-for="({ fight, startTime, scoreboardType }, fightIndex) in filteredFightsForMat[mat.id]"
                    :fight="fight"
                    :fight-index="fightIndex"
                    :start-time="startTime"
                    :key="fight.id"
                    :event-timezone="store.eventTimezone"
                    :fight-queue-statuses="store.fightQueueStatuses"
                    :tracked-time-for-fights="store.trackedTimeForFights"
                    :show-category-header="true"
                    :color-schema="getColorSchema(scoreboardType)"
                >
                    <template v-slot:after-first-competitor="{ competitor }">
                        <CompetitorCallCount
                            v-if="fight.id > 0 && competitor.id > 0"
                            :fight="fight"
                            :event-registration-id="competitor.id"
                        />
                    </template>
                    <template v-slot:after-second-competitor="{ competitor }">
                        <CompetitorCallCount
                            v-if="fight.id > 0 && competitor.id > 0"
                            :fight="fight"
                            :event-registration-id="competitor.id"
                        />
                    </template>
                </SingleFight>
            </transition-group>
        </template>
    </div>
</template>

<script setup lang="ts">
    import { useAnnouncerBoardStore } from "./announcerBoardStore";
    import SingleFight from "../Common/Fights/SingleFight.vue";
    import { storeToRefs } from "pinia";
    import Notification from "../Common/Notification.vue";
    import translatorMixin from "../Common/translatorMixin";
    import CompetitorCallCount from "./CompetitorCallCount.vue";
    import { getColorSchema } from "../Common/Fights/colorSchema";

    const store = useAnnouncerBoardStore();

    const { translate } = translatorMixin.methods;

    const { filteredFightsForMat, matNameById, haveFightsForCurrentPage } = storeToRefs(store);
</script>

<style scoped>
    .mat-name {
        top: 0;
    }

    .list-move, /* apply transition to moving elements */
    .list-enter-active,
    .list-leave-active {
        transition: all 0.5s ease;
    }

    .list-enter-from,
    .list-leave-to {
        opacity: 0;
        transform: translateX(30px);
    }

    /* ensure leaving items are taken out of layout flow so that moving
       animations can be calculated correctly. */
    .list-leave-active {
        position: absolute;
    }
</style>
